import React, {useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {useHistory} from 'react-router-dom'
import * as auth from './redux/AuthRedux'
import {logoutSession} from './redux/AuthCRUD'

export function Logout() {
  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    let active = true

    const performLogout = async () => {
      try {
        await logoutSession()
      } catch {
        // Always clear client auth state even when logout endpoint fails.
      } finally {
        dispatch(auth.actions.logout())
        if (active) {
          history.replace('/auth/login')
        }
      }
    }

    performLogout()
    return () => {
      active = false
    }
  }, [dispatch, history])

  return null
}
